export default __webpack_public_path__ + "static/media/branch_location.031c3fbe.svg";